<div id="splash-screen" [class.animate]="showLoadingSpinner">
  <ng-container *ngIf="showContent">
    <img class="logo" src="/assets/logo.svg" />

    <lipp-loading-spinner [color]="'white'"></lipp-loading-spinner>
  </ng-container>
</div>
